<template>
    <div id="Purchases">
        <Header :From="'Profile'" id="Header"/>
        <CContainer class="d-flex content-center min-vh-90" id="container">
      <div class="row p-0 m-0">
        <div class="col-lg-4 col-md-4 col-sm-12"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 p-0 m-0 box account-box">
        <div class="title">
            <img src="/icons_2/prev.png" alt="" @click="$router.go(-1)" />
            <span> {{ $t("Purchase.MyPurchase") }} </span>
        </div>

        <div class="purchases">
            <div class="purchase" v-for="(item, index) in purchases" :key="'purchase'+item.id">
                <div :class="selected_purchase==index?'header active':'header'" @click="selected_purchase==index?selected_purchase=null:selected_purchase=index">
                    <div class="flex">
                        <div class="left">
                            <span class="ref"><b>{{ $t("Purchase.Reference") }}:</b> Fripy-C-{{item.id}}</span>
                            <span class="price"><b>{{ $t("Purchase.Price") }}:</b> {{item.total_price}}<sup>DT</sup></span>
                            <!-- <span class="price" v-if="item.payed_ammount > 0">
                                <b>Prépayé:</b> {{item.payed_ammount}}<sup>DT</sup>
                            </span> -->
                            <span class="shipping"><b>{{ $t("Purchase.Delivery") }}:</b> 7<sup>DT</sup></span>
                        </div>
                        <div class="right">
                            <b style="display: block;">{{item.total_price+7-item.payed_ammount}}<sup>DT</sup> {{ $t("Purchase.ToPay") }}</b>
                            <span class="custom-badge" v-if="!item.status">{{ $t("Purchase.Hold") }}</span>
                            <span class="custom-badge" v-else :style="'background: '+item.status.color">{{item.status.name}}</span>
                        </div>
                    </div>
                    <div class="footer">
                        <font-awesome-icon class="faIcon" icon="angle-down" v-if="selected_purchase!=index"/>
                        <font-awesome-icon class="faIcon" icon="angle-up" v-else/>
                    </div>
                </div>
                <div class="body" v-if="selected_purchase==index">
                    <div class="info-purchase">
              
                        
                                <div><b>{{ $t("Purchase.Date") }}</b></div>
                                <div>{{item.purchased_at}}</div>
                                </div>
                                <div class="info-purchase">
                                <div><b>{{ $t("Purchase.PrePay") }}</b></div>
                                <div>{{item.payed_ammount}}<sup>DT</sup></div>
                                </div>
                                <div class="info-purchase">
                                    
                                    <div><b>{{ $t("Purchase.State") }}</b></div>
                                <div>{{item.status?item.status.name:$t("Purchase.Hold")}}</div>
                                </div>
                                <div v-if="item.status" class="info-purchase">
                                <div>{{item.status.message}}</div>
                                <div></div>
                                </div>
                                <div v-if="item.note && item.note!=''" class="info-purchase">
                                    <b>{{ $t("Purchase.Note") }}:</b> {{item.note}}
                                <div></div>
                                </div>
                                <!-- <td>{{item.purchased_at}}</td> -->
         
                                <!-- <td><b>Pré payé</b></td>
                                <td>{{item.payed_ammount}}<sup>DT</sup></td>
                    
                                <td><b>Etat</b></td>
                                <td>{{item.status?item.status.name:'En attente'}}</td>
         
                            <tr v-if="item.status">
                                <td colspan="2" style="text-align: left;">{{item.status.message}}</td>
                            </tr>
                            <tr v-if="item.note && item.note!=''">
                                <td colspan="2" style="text-align: left;"><b>Note:</b> {{item.note}}</td>
                            </tr> -->
                 
                   
                    <div class="products">
                        <div class="product" v-for="product in item.products" :key="'product'+product.id">
                            <div class="image" @click="showGalleryEvent(product)">
                                <img :src="product.image" alt="">
                            </div>
                            <div class="infos">
                                <span>{{product.title}}</span>
                                <span>{{product.type}} {{product.brand}} {{product.size}}</span>
                                <span><b>{{ $t("Purchase.Reference") }}: </b>{{product.reference}}</span>
                                <span v-if="product.promo_price && product.promo_price < product.price">
                                    <b>{{product.promo_price}}<sup>DT</sup></b> &nbsp; &nbsp;
                                    <del>{{product.price}}<sup>DT</sup></del>
                                </span>
                                <span v-else><b>{{product.price}}<sup>DT</sup></b></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <vue-gallery-slideshow class="vh-100 vw-100" :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
        </div>
        </div>
    </CContainer>
    </div>
</template>

<script>
import { orderService } from '../../../_services'
import moment from 'moment'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import Header from '../../../components/Header.vue'

export default({
    data:()=>({
        purchases: [],
        selected_purchase: null,
        images: [''],
        index: null
    }),
    methods:{
        showGalleryEvent(item){
            this.index = 0;
            this.images = JSON.parse(item.photos);
        },
    },
    mounted(){
        let loader= this.$loading.show();
        orderService.getAllByUser().then(function(data){
            this.purchases = data.data.map((obj)=>{
                obj.purchased_at = moment(obj.created_at).format('DD-MM-YYYY HH:mm')
                obj.products.map((product)=>{
                    product.image = JSON.parse(product.photos)[0]
                    return product
                })
                return obj
            })
        }.bind(this)).finally(function(){
            loader.hide()
        }.bind(this))
    },
    components:{
        VueGallerySlideshow,
        Header
    }
})
</script>

<style lang="scss" scoped>
    #Purchases{
        .account-box {
    background: #fff;
  }
  .box {
    background: #fff;
    width: 100%;
    width: 50vw;
    margin-top: 70px !important;
    margin-left: 15px !important;
    box-shadow: 0 0 8px 1px #ddd;
    margin-bottom: 30px !important;
  }
        .title {
            letter-spacing: 2px;
            font-size: 20px;
            padding: 10px;
            border-bottom: 2px solid #ddd;
            color: #ef86c1;
            background: #fff;
            text-align: center;
            img {
                float: left;
                width: 30px;
                margin-top: 5px;
            }
        }
        .purchases{
            .purchase:not(.purchase:last-child){
                border-bottom: 1px solid #ef86c1;
            }
            .purchase{
                background: #fff;
                color: #333;
                width: 100%;
                .header{
                    padding: 20px 30px;
                    transition: .4s;
                    .flex{
                        display: flex;
                    }
                    .left{
                        width: 60%;
                        text-align: left;
                    }
                    .right{
                        width: 40%;
                        text-align: right;
                        b{
                            margin-bottom: 20px;
                            color: #333;
                            font-weight: 900px;
                        }
                        .custom-badge{
                            width: auto;
                            background: #666;
                            color: #fff;
                            border-radius: 3px;
                            display: inline-block;
                            padding: 5px 15px;
                        }
                    }
                    .footer{
                        width: 100%;
                        text-align: center;
                        .faIcon{
                            color: #ef86c1;
                            font-size: 22px;
                            font-weight: 100;
                            margin-top: 20px;
                        }
                    }
                    span{
                        display: block;
                        margin-bottom: 5px;
                    }
                }
                .active{
                    background: #ef86c1;
                    color: #fff;
                    .right{
                        b{
                            color: #fff;
                        }
                    }
                    .footer{
                        .faIcon{
                            color: #fff;
                        }
                    }
                }
                .body{
                    padding: 20px 30px;
                    transition: .5s;
                    background: #fa5f5f27;
                    .info-purchase {
                        display: flex;
                        justify-content: space-between;
                    }
                    table{
                        width: 100%;
                        b{
                            color: #555;
                        }
                        tr td:last-child{
                            text-align: right;
                        }
                    }
                    .products{
                        width: 100%;
                        .product{
                            display: flex;
                            width: 100%;
                            margin-top: 20px;
                            .image{
                                width: 30%;
                                text-align: left;
                                cursor: pointer;
                                img{
                                    width: 75px;
                                    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
                                }
                            }
                            .infos{
                                width: 100%;
                                text-align: right;
                                font-size: 12px;
                                border-bottom: 1px solid #ddd;
                                span{
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
